interface PinkGradientSliderProps {
  min: number
  max: number
  step: number
  value: number
  onChange: (value: number) => void
  label?: string
  formatValue?: (value: number) => string
}

export function PinkGradientSlider({
  min,
  max,
  step,
  value,
  onChange,
  label,
  formatValue
}: PinkGradientSliderProps) {
  const percentage = ((value - min) / (max - min)) * 100
  const displayValue = formatValue ? formatValue(value) : value.toFixed(1)

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className="relative pt-6 pb-2">
        {/* Value tooltip */}
        <div
          className="absolute -top-0 text-sm font-bold text-pink-600 transform -translate-x-1/2 pointer-events-none"
          style={{ left: `${percentage}%` }}
        >
          {displayValue}
        </div>

        {/* Range input */}
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onInput={(e) => onChange(parseFloat((e.target as HTMLInputElement).value))}
          className="pink-gradient-slider w-full"
          style={{
            background: `linear-gradient(to right, #fce4ec 0%, #ec4899 ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`
          }}
        />

        {/* Min/Max labels */}
        <div className="flex justify-between text-xs text-gray-400 mt-1">
          <span>{min}</span>
          <span>{max}</span>
        </div>
      </div>
    </div>
  )
}
